// extracted by mini-css-extract-plugin
module.exports = {"Section":"Settings_Section__2jBJ1","Template":"Settings_Template__yKejh","label":"Settings_label__19DEQ","Settings":"Settings_Settings__iAtwK"};